// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import App from './app';
import routes from './routes';
import storeOption from './vuex/store';
import http from './apis/http';
import system from "./constants/system.constants"
import profile from "./constants/profile.constants"
import vuetify from './plugins/vuetify'
import echarts from 'echarts';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@mdi/font/css/materialdesignicons.css'
import  '../static/custom_config.js?v=Math.randowm()'
import {loadingJs} from "./assets/js/load_js";


Vue.prototype.SYSTEM = system;
Vue.prototype.PROFILE = profile;
Vue.prototype.CUSTOM_CONFIG = {  isLocal:true,title:()=>""};
loadingJs('/static/custom_config.js?v=Math.randowm()',null).then(()=>{
    //你的初始化代码
    Vue.prototype.CUSTOM_CONFIG = CUSTOM_CONFIG;
});

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(ElementUI);

// 创建一个路由对象用于管理页面的路由
const router = new VueRouter({
    mode: 'history',
    routes: routes
});

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next();
    } else if (to.path.substring(0,7) == '/chart/' && to.query.token) {
        next();
    } else {
        let token = localStorage.getItem('Token');

        if (token == null || token === 'null' || token === '') {
            next('/login');
        } else {
            next();
        }
    }
});

// 创建一个 store 对象用于管理应用状态
const store = new Vuex.Store(storeOption);

window.__lendApp__ = new Vue({
    el: '#app',
    router,
    store,
    vuetify,
    render: h => h(App)
});

// 输入框在虚拟键盘弹出时，自动滚动到可见位置
document.body.addEventListener('click', function (event) {
    var element = event.target;
    var tags = {
        'INPUT': 1,
        'TEXTAREA': 1,
    }
    if ((element.tagName in tags)) {
        setTimeout(function () {
            element.scrollIntoViewIfNeeded();
            // console.log('scrollIntoViewIfNeeded');
        }, 400);
    }
}, false);

// 日期格式化
// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
/*
var ua = navigator.userAgent;
var isIpad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !isIpad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    isMobile = isIphone || isAndroid;

    //或者单独判断iphone或android
    if(isIphone){
        console.log("iphone访问");
        //code
        alert('iPhone访问');
    }else if(isAndroid){
        console.log("Android访问");
        //code
        alert('Andriod访问');
    }else{
        console.log("非iphone或Android访问");
        //code
        alert("非iphone或Android访问");
    }*/


// WEBPACK FOOTER //
// ./src/main.js